export const convertSecondsToTimeString = (seconds: number): string => {
    if (typeof seconds === "string") {
        seconds = Number(seconds);
    }

    if (typeof seconds !== "number" || !isFinite(seconds)) {
        return null;
    }

    const retString = new Date(seconds * 1000).toISOString();
    return seconds >= 3600 ? retString.substr(11, 8) : retString.substr(14, 5);
};

export default convertSecondsToTimeString;
